import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

let isRegistered = false

export function registerGsap(): void {
  if (isRegistered || typeof window === 'undefined') {
    return
  }

  gsap.registerPlugin(ScrollTrigger)
  ScrollTrigger.config({ ignoreMobileResize: true })
  isRegistered = true
}

export { gsap, ScrollTrigger }
